import { render, staticRenderFns } from "./GameSelectTrigger.vue?vue&type=template&id=046666c8&scoped=true&"
import script from "./GameSelectTrigger.vue?vue&type=script&lang=js&"
export * from "./GameSelectTrigger.vue?vue&type=script&lang=js&"
import style0 from "./GameSelectTrigger.vue?vue&type=style&index=0&id=046666c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046666c8",
  null
  
)

export default component.exports